import React from 'react';
import { DayCell } from './DayCell';
import { DayData } from '../utils/mockData';
interface WeekCalendarProps {
  data: DayData[];
}
export function WeekCalendar({
  data
}: WeekCalendarProps) {
  return <div className="bg-gray-800 rounded-xl p-6 border border-gray-700" data-id="element-61">
      <h2 className="text-xl font-bold text-white mb-6" data-id="element-62">This Week</h2>
      <div className="grid grid-cols-7 gap-3" data-id="element-63">
        {data.map((day, index) => <DayCell key={day.date} day={day} delay={index * 100} data-id="element-64" />)}
      </div>
    </div>;
}